import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box } from "theme-ui";
import { defaultTheme } from "../../theme/theme";
import { ImageVariants } from "../../theme/enums";
import { ArtDirectedImage } from "../Image/ArtDirectedImage";
import { ImgixImage, ImgixAspectRatio } from "../Image/ImgixImage";
import { Label2 } from "../Text/Label2";
import { TechnicalParagraph } from "../Text/TechnicalParagraph";
import { ParagraphSizeEnum } from "../Text/ParagraphSizeEnum";
import { Column } from "../Layout/Responsive/Column";
import { Row } from "../Layout/Responsive/Row";
import { Mobile } from "../Layout/Responsive/Mobile";
import { Desktop } from "../Layout/Responsive/Desktop";
import { CheckoutProductPriceColumn } from "./CheckoutProductPriceColumn";
import { NameAndValueRow } from "./NamesAndValues";
const { breakpoints = [] } = defaultTheme;
export const CheckoutSummaryProductPrice = ({ productPrice, discountNames, discountedPrice }) => (_jsx(CheckoutProductPriceColumn, { price: productPrice, discountNames: discountNames, discountPrice: discountedPrice, discountPriceColor: "black" }));
export const CheckoutSummaryProductCard = props => (_jsxs(Row, { sx: {
        marginBottom: 24,
        [`@media screen and (max-width: ${breakpoints[1]})`]: {
            display: "grid",
            gap: 16,
            marginBottom: 56,
            gridTemplateColumns: "1fr 5fr"
        }
    }, children: [_jsx(Box, { sx: {
                position: "relative",
                [`@media screen and (min-width: ${breakpoints[1]})`]: {
                    marginRight: 24,
                    width: 56
                }
            }, children: _jsx(Box, { sx: {
                    variant: `images.${ImageVariants.ratio_3x4}`
                }, children: _jsx(ArtDirectedImage, { imageNode: _jsx(ImgixImage, { imageUrl: props.productImageUrl, imageAlt: props.productImageTitle || "", width: 56, sizes: "56px", aspectRatio: ImgixAspectRatio.ar3x4 }), imageAlt: props.productImageTitle || "" }) }) }), _jsxs(Column, { sx: { width: "100%" }, children: [_jsxs(Row, { sx: { mb: 12 }, children: [_jsxs(Column, { children: [_jsx(Label2, { sx: { color: "grey.0", mb: 0 }, children: props.productName }), _jsx(TechnicalParagraph, { variant: ParagraphSizeEnum.small, sx: { color: "grey.1", maxWidth: "24ch" }, children: props.productDescription })] }), _jsx(Desktop, { sx: {
                                marginLeft: "auto",
                                textAlign: "right",
                                width: 104
                            }, children: _jsx(CheckoutSummaryProductPrice, Object.assign({}, props)) })] }), _jsxs(Box, { children: [_jsx(NameAndValueRow, { name: props.translations.color, value: props.productColor }), _jsx(NameAndValueRow, { name: props.translations.size, value: props.productSize }), _jsx(NameAndValueRow, { name: props.translations.quantity, value: props.productQuantity }), _jsx(NameAndValueRow, { name: props.translations.sku, value: props.productSku }), _jsx(Mobile, { children: _jsx(CheckoutSummaryProductPrice, Object.assign({}, props)) })] })] })] }));
//# sourceMappingURL=CheckoutSummaryProductCard.js.map